import React from 'react'

export default function GameLoading () {
  return (
    <main className="fill-green-gradient">
      <header className="banner">
        Loading...
      </header>

      <div className="container">
        <section className="card pad-8">
          <h2>Just a sec...</h2>
          <p>
            Scouring the bowels of the internet is taking longer than
            expected. Please wait.
          </p>
        </section>
      </div>
    </main>
  )
}



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/loading.jsx
 **/